import { createFileRoute } from "@tanstack/react-router";
import { CinemaServicePage } from "./services_.cinema";

export const Route = createFileRoute("/dev_/service_/cinema-advertising-services")({
  head: () => ({
    meta: [
      {
        title: "Cinema Advertising Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Captive Big-Screen Cinema Advertising & Multiplex Media Spotting.",
      },
    ],
  }),
  component: CinemaServicePage,
});
